export default "__VITE_ASSET__DPM2UxWQ__"